import { ViewerCommand } from './ViewerCommand';
import { ViewerEvents } from '../../Viewer';
import { ObjectDisplayMode } from '../../Objects/Part3D';
export class ChangeVisibilityCommand extends ViewerCommand {
    constructor(objects, newVisibilityValues, viewer) {
        super(viewer, objects);
        if (objects.length !== newVisibilityValues.length) {
            throw new Error('length of newVisibilityValues array must be equal to a length of objects array');
        }
        this.type = 'ChangeVisibilityCommand';
        this.name = this.composeName();
        this.newVisibilityValues = newVisibilityValues.slice();
        this.oldVisibilityValues = objects.map((object) => object.visible);
    }
    execute() {
        this.objects.forEach((object, index) => {
            this.setVisibilityRecursively(object, this.newVisibilityValues[index]);
        });
        this.viewer.emit(ViewerEvents.ObjectsVisibilityChanged, this.objects.map((object) => object.uuid));
    }
    setObjectVisibility(obj, visibility) {
        var _a;
        if (obj.userData.isWireframe) {
            return;
        }
        obj.userData.isVisible = visibility;
        if (!obj.userData.hasOwnProperty('mode') || obj.userData.mode === ObjectDisplayMode.Normal) {
            obj.visible = visibility;
        }
        else if ((_a = obj === null || obj === void 0 ? void 0 : obj.userData) === null || _a === void 0 ? void 0 : _a.wireframe) {
            obj.userData.wireframe.visible = visibility;
        }
    }
    setVisibilityRecursively(root, visibility) {
        const stack = [root];
        while (stack.length) {
            const obj = stack.pop();
            if (obj === undefined) {
                throw new Error("Stack is unexpectedly empty");
            }
            this.setObjectVisibility(obj, visibility);
            stack.push(...obj.children);
        }
    }
    undo() {
        this.objects.forEach((object, index) => {
            object.visible = this.oldVisibilityValues[index];
            this.setVisibilityRecursively(object, object.visible);
        });
        this.viewer.emit(ViewerEvents.ObjectsVisibilityChanged, this.objects.map((object) => object.uuid));
    }
    update(cmd) {
        throw new Error(`${this.type} can not be updated`);
    }
    toJSON() {
        const output = super.toJSON();
        output.newVisibilityValues = this.newVisibilityValues.slice();
        output.oldVisibilityValues = this.oldVisibilityValues.slice();
        return output;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.newVisibilityValues = json.newVisibilityValues.slice();
        this.oldVisibilityValues = json.oldVisibilityValues.slice();
    }
}
